import { useMemo } from "react";
import { Field } from "react-final-form";

import RffInputWrapper from "../shared/RffInputWrapper";
import SelectMultipleCheckboxInput from "../../inputs/SelectMultipleCheckboxInput";

import { VALIDATOR_REQUIRE } from "../../../utils/finalForm/validators/VALIDATOR_REQUIRE";

// Multi-select with a checkbox next to each option in the dropdown. The
// dropdown stays open across selections (disableCloseOnSelect on the
// underlying Autocomplete), so users can toggle several values without
// reopening it.
const RffSelectMultipleCheckboxField = ({
  name,
  label,
  options,
  required = false,
  suppressGrid,
  helperText,
  row = false,
  size,
  chipMaxWidth = "150px",
  placeholder,
  disableStacking = false,
}) => {
  const validate = useMemo(
    () => (required ? VALIDATOR_REQUIRE : undefined),
    [required],
  );

  return (
    <RffInputWrapper
      label={label}
      suppressGrid={suppressGrid}
      size={size}
      row={row}
      helperText={helperText}
      required={required}
    >
      <Field
        name={name}
        validate={validate}
        render={({ input, meta }) => (
          <SelectMultipleCheckboxInput
            value={input?.value || []}
            onChange={(v) => input.onChange(v)}
            options={options}
            chipMaxWidth={chipMaxWidth}
            placeholder={placeholder}
            disableStacking={disableStacking}
            error={meta.touched && !!meta.error}
            helperText={(meta.touched && meta.error) || helperText}
          />
        )}
      />
    </RffInputWrapper>
  );
};

export default RffSelectMultipleCheckboxField;
